/**
 * Texto humano das classificações do POST /tenants/{id}/prepare.
 *
 * O banner imprimia a classificação crua (`oar_access_denied`) como título do
 * erro. Classificação é para o log e para o suporte; para quem está na tela, o
 * que importa é o que fazer a seguir — e por isso ela continua visível, em letra
 * pequena, ao lado da frase.
 */
const MENSAGENS: Record<string, string> = {
  oar_missing:
    'A conta deste tenant não tem o papel OrganizationAccountAccessRole, que a ' +
    'preparação usa para escrever permissões. É o que acontece quando a conta ' +
    'entrou na organização por convite: nesse caso o papel não é criado. A ' +
    'configuração tem de ser feita fora desta tela — ver runbook.',
  oar_access_denied:
    'A plataforma não conseguiu assumir o OrganizationAccountAccessRole na conta ' +
    'do tenant. Confirme com o time de plataforma se o papel existe e se confia ' +
    'na conta de gestão da organização.',
  external_id_mismatch:
    'Os dois lugares que guardam o identificador externo do ZTNA estão com ' +
    'valores diferentes, e escrever a permissão com um deles produziria um ' +
    'acesso que o outro não consegue usar. É configuração da plataforma — ver ' +
    'runbook.',
  tenant_account_id_missing:
    'Este tenant não tem account_id cadastrado. Corrija o cadastro antes de ' +
    'preparar.',
  cross_account_not_configured:
    'A integração cross-account não está configurada nesta instalação. Acione o ' +
    'time de plataforma.',
  secret_unavailable:
    'A plataforma não conseguiu ler o segredo da integração. Tente de novo; se ' +
    'persistir, acione o time de plataforma.',
  tenant_assume_denied:
    'A permissão foi escrita, mas o acesso ainda não passou. Pode ser propagação ' +
    'do IAM — reveja em 1 minuto. Se persistir, é a permissão de confiança ou o ' +
    'identificador externo.',
  unknown:
    'A permissão foi escrita, mas o acesso ainda não passou, e a causa não veio ' +
    'classificada. Reveja em 1 minuto; se persistir, acione o time de plataforma.',
}

const PADRAO =
  'Falha ao preparar o tenant. Tente de novo; se persistir, acione o time de ' +
  'plataforma.'

/**
 * Classificações em que não existe botão que resolva — precisa de ação fora da
 * tela. Só nesses casos o link do runbook aparece: link em toda falha vira
 * decoração, e quem lê para de clicar.
 */
export const PRECISA_DE_RUNBOOK: ReadonlySet<string> = new Set([
  'oar_missing',
  'external_id_mismatch',
])

export function prepareErrorMessage(classification: string): string {
  return MENSAGENS[classification] ?? PADRAO
}
